import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { SalesPackage } from 'app/main/models/salespackage/salespackage.model';
import { SalesPackageService } from 'app/main/services/salespackage.service';

type SalespackageCardComponentMode =
  "DEFAULT" | "ESTIMATION";

@Component({
  selector: 'app-salespackage-card',
  templateUrl: './salespackage-card.component.html',
  styleUrls: ['./salespackage-card.component.scss']
})
export class SalespackageCardComponent implements OnInit {

  @Input() salespackage: SalesPackage;
  @Input() hideRating: boolean;
  @Input() mode: SalespackageCardComponentMode;
  @Input() disableHover: boolean;

  @Output() selectedSalesPackage: EventEmitter<any>;

  showNumber: boolean;
  rating: number;
  imageUrl: string;

  stopRender: boolean;
  isDark: boolean;

  constructor(
    private router: Router,
    private salesPackageService: SalesPackageService
  ) {
    this.selectedSalesPackage = new EventEmitter<any>();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['salespackage']) {
      this.salespackage = changes['salespackage'].currentValue;
    }
    if (changes['hideRating']) {
      this.hideRating = changes['hideRating'].currentValue;
    }
    if (changes['disableHover']) {
      this.disableHover = changes['disableHover'].currentValue;
    }
    if (changes['mode']) {
      this.mode = changes['mode'].currentValue;
    }
    this.initialize();
  }

  async ngOnInit() {
    this.initialize();
  }

  initialize() {
    if (this.salespackage) {
      this.rating = this.salespackage.averageValue;
      this.showNumber = true;
      // this.imageUrl = 'http://192.168.2.166:8200/exellente/metodi-lettura-tarocchi.jpg';
      this.imageUrl = this.salesPackageService.retrieveSalespackageImageUrl(this.salespackage);
      if (!this.mode) {
        this.mode = 'DEFAULT';
      }
    }
  }

  /*   async goToDetail(subscriptionId) {
      await this.router.navigate(['/common-area/subscription/' + subscriptionId + '/detail']);
    } */

  async onCardClicked(salespackage) {
    if (this.mode === 'DEFAULT') {
      await this.goToDetail(salespackage.id);
    } else {
      this.selectedSalesPackage.emit(salespackage);
    }
  }

  async goToDetail(salespackageId) {
    await this.router.navigate(['/common-area/salespackage/' + salespackageId + '/detail']);
  }

  /* checkImageRendered() {
    const img: any = document.getElementById(this.imageUrl) as HTMLElement;
    if (img) {
      img.isDark = this.isImageDark(img, 150, 20);
    }
  }

  isImageDark(image, threshold, fuzz) {
    if (!threshold) {
      threshold = 127;
    }
    if (fuzz === undefined || fuzz < 0 || fuzz % 2 !== 0) {
      fuzz = 1;
    }
    const c = document.createElement('canvas');
    const ctx = c.getContext('2d');
    c.width = image.width;
    c.height = image.height;
    image.crossOrigin = 'Anonymous';
    ctx.drawImage(image, 0, 0);

    const data = ctx.getImageData(0, 0, c.width, c.height).data;
    let totalGrey = 0;

    for (let i = 0, ln = data.length, inc = 4 * fuzz; i < ln; i += inc) {
      const r = data[i],
        g = data[i + 1],
        b = data[i + 2],
        grey = Math.floor((r + g + b) / 3);

      totalGrey += grey;
    }

    const area = (c.width * c.height) / fuzz,
      lightLevel = Math.floor(totalGrey / area);
    this.isDark = (lightLevel < threshold);

    return this.isDark;
  } */




}
